import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Checkbox, Autocomplete, TextField } from '@mui/material';

// icons
import { CheckBoxOutlineBlank as UnCheckIcon, CheckBox as CheckedIcon } from '@mui/icons-material';

function UserGroupsSelections({
	userGroups,
	handleUserGroupsChange,
	onUserGroupsSelectionFinish,
	...rest
}) {
	const intl = useIntl();
	// const [isSelectingUserGroups, setIsSelectingUserGroups] = React.useState(false);
	return (
		<Autocomplete
			sx={{
				// mb: 1,
				minWidth: 300,
				width: '100%',
				maxHeight: 250,
			}}
			multiple
			id="components-usergroupsSelections"
			options={userGroups}
			// disableCloseOnSelect
			getOptionLabel={(option) => option.name}
			slotProps={{ chip: { color: 'primary' } }}
			renderOption={(props, option, { selected }) => {
				return (
					<div {...props}>
						<Checkbox
							icon={<UnCheckIcon fontSize="small" />}
							checkedIcon={<CheckedIcon fontSize="small" />}
							style={{ marginRight: 8 }}
							checked={selected}
						/>
						{`${option.name} (${option.userCount})`}
					</div>
				);
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					label={intl.formatMessage({
						id: 'components.UsSelectionsMUIDialog.UserGroupsSelectionsLabel',
					})}
					placeholder="Typing to search"
				/>
			)}
			onChange={(e, value) => {
				handleUserGroupsChange(value);
				// if (!isSelectingUserGroups) {
				onUserGroupsSelectionFinish(value);
				// }
				// setIsSelectingUserGroups(false);
			}}
			// onClose={() => {
			// 	setIsSelectingUserGroups(false);
			// 	// onUserGroupsSelectionFinish();
			// }}
			// onOpen={() => setIsSelectingUserGroups(true)}
		/>
	);
}

UserGroupsSelections.propTypes = {
	userGroups: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			userCount: PropTypes.number,
		})
	).isRequired,
	handleUserGroupsChange: PropTypes.func.isRequired,
	onUserGroupsSelectionFinish: PropTypes.func,
};

UserGroupsSelections.defaultProps = {};

export default UserGroupsSelections;
